import { gql } from "@apollo/client";

const deletePrivateNoteMutation = gql`
  mutation deletePrivateNoteMutation($privateNoteId: Int!) {
    deletePrivateNote(privateNoteId: $privateNoteId) {
      deletedPrivateNoteId
    }
  }
`;

export default deletePrivateNoteMutation;
